import { render, staticRenderFns } from "./NoticiasAprovadas.vue?vue&type=template&id=74bf6ce1&scoped=true"
import script from "./NoticiasAprovadas.vue?vue&type=script&lang=js"
export * from "./NoticiasAprovadas.vue?vue&type=script&lang=js"
import style0 from "./NoticiasAprovadas.vue?vue&type=style&index=0&id=74bf6ce1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bf6ce1",
  null
  
)

export default component.exports